import React from "react";

import { useTranslation } from 'react-i18next';

const ExecutedAndBalanceChart = (props) => {
    const { t } = useTranslation('bayphone')
    const { executedPct, metaPct } = props;
    const year = props.year || new Date().getFullYear();
    const saldoPct = 100 - executedPct;

    const chartColors = ["#35acda", "#2678dd"];

    return (
        <div style={{ width: "100%", display: "flex" }}>
            <div style={{ textAlign: "center", width: "70%" }}>
                <h3 style={{ color: "#1f4a5c", fontSize: 14, fontWeight: "bold", paddingTop: 10, width: "100%" }}>
                    {t('Executed vs. Planed budget')}
                </h3>

                <div style={{ position: "relative", height: 45, width: "100%", margin: "auto", display: "flex", borderLeft: "2px solid black" }}>
                    <div style={{ position: "relative", height: 35, width: "100%", margin: "auto", display: "flex" }}>
                        {/* Bar for Executed */}
                        <div
                            style={{
                                width: `${executedPct}%`,
                                backgroundColor: chartColors[0], //"#9ccc1b",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#000",
                                fontWeight: "bold",
                            }}
                        >
                            {executedPct?`${executedPct}%`:null}
                        </div>

                        {/* Bar for Balance */}
                        <div
                            style={{
                                width: `${saldoPct}%`,
                                backgroundColor: chartColors[1], //"#29b6f6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#000",
                                fontWeight: "bold",
                            }}
                        >
                            {saldoPct?`${saldoPct}%`:null}
                        </div>
                    </div>

                    {/* Dotted line for Meta */}
                    <div
                        style={{
                            position: "absolute",
                            left: `${metaPct}%`,
                            top: 0,
                            bottom: 0,
                            borderLeft: "2px dashed black",
                        }}
                    ></div>
                </div>

                <div style={{ marginTop: 0, color: "#1f4a5c", fontSize: 14 }}>
                    {/* Row for Meta Percentage */}
                    <div style={{ position: "relative", height: 30, width: "100%", margin: "auto" }}>
                        <div
                            style={{
                                position: "absolute",
                                left: `calc(${metaPct}% - 12px)`,
                                top: 0,
                                textAlign: "right",
                                fontWeight: "bold",
                                fontSize: 14,
                            }}
                        >
                            {metaPct}%
                        </div>
                    </div>
                </div>
            </div>
            {/* Leyend */}
            <div style={{ textAlign: "left", width: "30%", marginLeft: 10, marginTop: 30 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 15, height: 7, backgroundColor: chartColors[0] }}></div>
                    <span>{t('Executed')}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 15, height: 7, backgroundColor: chartColors[1] }}></div>
                    <span>{t('Balance')}</span>
                </div>
            </div>
        </div>
    );
}

export default ExecutedAndBalanceChart;